let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("g7pmM")]).then(() => parcelRequire('fe39K'));